import React, { Component } from 'react';
import './Legend.css';
import CptrLogo from '../images/cptr_logo.png';
import infoTooltip from '../images/info-tooltip.png';

export class Legend extends Component {
  render() {
    return (
      <div>
        <div>
          <img
            src={CptrLogo}
            className="logo"
            alt="CPTR Logo"
          />
        </div>

        <div id="legend">
          <div className="title_container">
            <h4 className="title">
              Change in
              <br />
              Median Tax Bill
            </h4>
            <div>
              <div className="tooltip">
                <img
                  src={infoTooltip}
                  alt="Info Tooltip"
                  id="median_tax_tooltip"
                />
                <span className="tooltiptext">
                  The map at city - level view shows the difference in the median household
                  tax bill as a dollar difference from the current scenario.
                  <br />
                  <br />
                  Use the slider at the bottom of the page to show the projected difference in
                  median tax bill based on how much of the city's property revenue comes from a
                  tax on land value.
                  <br />
                  <br />
                  Click on each analysis zone
                  for more information.
                </span>
              </div>
            </div>
          </div>
          <div
            id="color_grad"
            className="legend_col"
          />
          <div className="legend_col">
            <div className="row">
              <p>
                +$1000
              </p>
            </div>

            <div className="row">
              <p>
                +$500
              </p>
            </div>

            <div className="row">
              <p>
                +$300
              </p>
            </div>

            <div className="row">
              <p>
                +$100
              </p>
            </div>
            <div className="row">
              <p>
                +$50
              </p>
            </div>

            <div className="row">
              <p>
                $0
              </p>
            </div>
            <div className="row">
              <p>
                -$50
              </p>
            </div>
            <div className="row">
              <p>
                -$100
              </p>
            </div>
            <div className="row">
              <p>
                -$300
              </p>
            </div>

            <div className="row">
              <p>
                -$500
              </p>
            </div>

            <div className="row">
              <p>
                -$1000
              </p>
            </div>

            <div className="row">
              <p>
                No Data
              </p>
            </div>
          </div>
          <div id="noData" />
          <div
            id="parcel_title"
            className="title_container"
          >
            <h4 className="title">
              Parcel Types
            </h4>
            <div>
              <div className="tooltip">
                <img
                  src={infoTooltip}
                  alt="Info Tooltip"
                  id="parcel_tooltip"
                />
                <span className="tooltiptext">
                  Zoom in to street level to see individual parcels.
                  <br />
                  <br />
                  Click on a parcel to see how each projected tax scenario affects a property's tax bill.

                </span>
              </div>
            </div>
          </div>
          <div id="parcel_legend">
            <div className="p_row">
              <div id="residential_dot" />
              <p className="parcel_text">
                Residential
              </p>
            </div>

            <div className="p_row">
              <div id="commercial_dot" />
              <p className="parcel_text">
                Commercial
              </p>
            </div>

            <div className="p_row">
              <div id="mixed_use_dot" />
              <p className="parcel_text">
                Mixed Use
              </p>
            </div>

            <div className="p_row">
              <div id="industrial_dot" />
              <p className="parcel_text">
                Industrial
              </p>
            </div>

            <div className="p_row">
              <div id="vacant_dot" />
              <p className="parcel_text">
                Vacant Land
              </p>
            </div>

            <div className="p_row">
              <div id="exempt_dot" />
              <p className="parcel_text">
                No Tax Liability
              </p>
            </div>

            <div className="p_row">
              <div id="abated_dot" />
              <p className="parcel_text">
                No Tax Liability
                <br />
                on
                Buildings/
                Improvements
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
